import { DatavizDarkTheme } from "../.internal/themes/DatavizDarkTheme";
export default DatavizDarkTheme;
